import { SVGProps } from 'react';
import { getFieldSvgDataUri, type FieldSelection } from '../../../../utils/fieldSelection';

export {
  DEFAULT_FIELD_SELECTION,
  FIELD_FAMILIES,
  FIELD_FAMILY_MANIFEST,
  FIELD_MANIFEST,
  FIELD_OPTIONS,
  createDefaultFieldSelection,
  formatFieldLabel,
  getDefaultFieldSelectionForFamily,
  getFieldFamilyLabel,
  getFieldFamilyLabelDefault,
  getFieldFamilyLabelDescriptor,
  getFieldGeometry,
  getFieldOptionsForFamily,
  getOrderedFieldFamilies,
  getFieldVariantLabel,
  getFieldVariantLabelDefault,
  getFieldVariantLabelDescriptor,
  isFieldSelection,
  normalizeFieldSelection,
} from '../../../../utils/fieldSelection';

type FieldSvgProps = SVGProps<SVGImageElement> & {
  'data-path-builder-pan-surface'?: string;
};

export const resolveFieldSvg = (selection: FieldSelection, props: FieldSvgProps): JSX.Element => {
  const dataUri = getFieldSvgDataUri(selection);

  return <image {...props} href={dataUri} xlinkHref={dataUri} />;
};
